export const GUIDES = {
  earlyOut: "vera-vsip-mra10-federal-early-out-options",
  deferredResignation: "deferred-resignation-what-it-means-for-your-fers-pension",
  fehb: "fehb-five-year-rule-keeping-health-insurance-in-retirement",
  earningsTest: "fers-supplement-earnings-test-explained",
};
export const guideUrl = (k) => `/learn/${GUIDES[k]}`;
